"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var service_service_1 = require("./../Services/service.service");
var core_1 = require("@angular/core");
var router_1 = require("@angular/router");
var AddWritterView;
(function (AddWritterView) {
    AddWritterView[AddWritterView["Loading"] = 0] = "Loading";
    AddWritterView[AddWritterView["FormAndPayment"] = 1] = "FormAndPayment";
    AddWritterView[AddWritterView["SendInformationCompleted"] = 3] = "SendInformationCompleted";
})(AddWritterView || (AddWritterView = {}));
var AdvWithUsComponent = /** @class */ (function () {
    function AdvWithUsComponent(mainService, router) {
        this.mainService = mainService;
        this.router = router;
        this.enableAdvertiseWithUs = false;
        this.enableAdvertiseWithUs = mainService.enableAdvertiseWithUs;
        if (!this.enableAdvertiseWithUs) {
            this.router.navigate(['']);
        }
    }
    AdvWithUsComponent.prototype.ngOnInit = function () {
        this.mainService.hideLoader(true);
    };
    return AdvWithUsComponent;
}());
exports.AdvWithUsComponent = AdvWithUsComponent;
